import React from 'react';

// Breadcrumb
const Breadcrumb = ({ image, crumb, description, budgets, links }) => (
  <section className="header-content">
    <div className="text block-left-breadcrumb">
      {image && <div className="image" style={{ backgroundImage: `url(${image})` }} />}
      <div className="bread-titles mg-xs-top-20">
        <h2 className="title">{crumb}</h2>
        <h3 className="subtitle">
          {description}
          {' '}
        </h3>
      </div>
      {budgets && (
        <div className="bread-info">
          <span className="text"><span className="text-light">Meu Budget: </span> {' '} <span>R$600,00 </span></span>
          {' '}
          <span className="text"><span className="text-light">Saldo: </span> {' '}<span>R$556,00</span></span>
        </div>
      )}
      {links && (
        <div className="bread-info">
          {links.map(item => (
            <a>{item.name}</a>
          ))}
        </div>
      )}
    </div>
  </section>
);

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/shared/breadcrumb/Breadcrumb.jsx